var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('HeaderView'),_c('router-view'),_c('FooterView'),_c('FixedView',{attrs:{"show":_vm.isShowUp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }